import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Sorry, page not found</h1>
            <h3>404 Error!!!</h3>
        </div>
    );
};

export default NotFound;